import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import INFO from "../../data/user";

import styles from "./styles/socials.module.css";

const Socials = () => {
  return (
    <div>
      <div className={styles["social"]}>
        <a href={INFO.socials.github} target="_blank" rel="noreferrer">
          <div className={styles["social-icon"]}>
            <FontAwesomeIcon
              icon={faGithub}
              className={styles["social-icon"]}
            />
          </div>
          <div className={styles["social-text"]}>GitHub</div>
        </a>
      </div>

      <div className={styles["social"]}>
        <a href={INFO.socials.linkedin} target="_blank" rel="noreferrer">
          <div className={styles["social-icon"]}>
            <FontAwesomeIcon
              icon={faLinkedin}
              className={styles["social-icon"]}
            />
          </div>
          <div className={styles["social-text"]}>LinkedIn</div>
        </a>
      </div>

      <div className={styles["social"]}>
        <a href={INFO.socials.instagram} target="_blank" rel="noreferrer">
          <div className={styles["social-icon"]}>
            <FontAwesomeIcon
              icon={faInstagram}
              className={styles["social-icon"]}
            />
          </div>
          <div className={styles["social-text"]}>Instagram</div>
        </a>
      </div>

      <div className={styles["email"]}>
        <div className={styles["email-wrapper"]}>
          <a
            href={`mailto:${INFO.main.email}`}
            target="_blank"
            rel="noreferrer"
          >
            <div className={styles["social-icon"]}>
              <FontAwesomeIcon icon={faEnvelope} />
            </div>

            <div className={styles["social-text"]}>{INFO.main.email}</div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Socials;
